import * as mutation from "./mutation-types";
import * as action from "./action-types";
import * as lcMutation from "@/store/levy-collections/mutation-types";
import * as lcpMutation from "@/store/levy-collection-providers/mutation-types";
import * as lcpAction from "@/store/levy-collection-providers/action-types";
import * as systemLogMutation from "@/store/system-logs/mutation-types";
import { GLOBAL_ERROR } from "@/store/system/mutation-types";
import { deepCopyAxiosException } from "@/store/helpers";
import { tableHelper } from "@/helpers/table.helper";
import axios from "axios";
import store from "@/store";

export const actions = {
  async [action.LIST]({ commit, state }) {
    commit(mutation.LIST_STARTED);
    try {
      const url = tableHelper.constructUrl(`/api/providers/${state.listing.providerId}/notes`, state.listing.paging);
      const { data } = await axios.get(url);
      commit(mutation.LIST_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.LIST_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.EDIT_GET]({ commit }, { providerId, noteId }) {
    commit(mutation.EDIT_GET_STARTED);
    try {
      const url = `/api/providers/${providerId}/notes/${noteId}`;
      const { data } = await axios.get(url);
      commit(mutation.EDIT_GET_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.EDIT_GET_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.EDIT_SAVE]({ commit, state, dispatch }, { providerId, levyCollectionId }) {
    commit(mutation.EDIT_SAVE_STARTED);
    try {
      let url = `/api/providers/${providerId}/notes`;
      if (!state.edit.isNew) {
        await axios.put(`${url}/${state.edit.data.id}`, state.edit.data);
      } else {
        await axios.post(url, state.edit.data);
      }
      commit(mutation.STATE_UNLOAD);
      commit(systemLogMutation.STATE_UNLOAD);
      if (levyCollectionId) {
        await dispatch(lcpAction.EXISTS, { levyCollectionId: levyCollectionId, providerId });
        commit(mutation.STATE_UNLOAD);
        commit(lcMutation.STATE_UNLOAD);
        const onlyUnloadListing = !store.state.levyCollectionProviders.exists.exists;
        commit(lcpMutation.STATE_UNLOAD, onlyUnloadListing);
      }
      commit(mutation.EDIT_SAVE_SUCCEEDED);
      return true;
    } catch (e) {
      commit(mutation.EDIT_SAVE_FAILED, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.EDIT_DELETE]({ commit, dispatch }, { providerId, levyCollectionId, noteId }) {
    commit(mutation.EDIT_DELETE_STARTED);
    try {
      const url = `/api/providers/${providerId}/notes/${noteId}`;
      await axios.delete(url);
      commit(mutation.STATE_UNLOAD);
      commit(systemLogMutation.STATE_UNLOAD);
      if (levyCollectionId) {
        await dispatch(lcpAction.EXISTS, { levyCollectionId: levyCollectionId, providerId });
        commit(mutation.STATE_UNLOAD);
        commit(lcMutation.STATE_UNLOAD);
        const onlyUnloadListing = !store.state.levyCollectionProviders.exists.exists;
        commit(lcpMutation.STATE_UNLOAD, onlyUnloadListing);
      }
      commit(mutation.EDIT_DELETE_SUCCEEDED);
      return true;
    } catch (e) {
      commit(mutation.EDIT_DELETE_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  }
};
